import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const ListrikPln = (props: IIconProps) => (
  <Icon viewBox="0 0 28 28" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.692 25.537a64.147 64.147 0 0 0 3.006-19.225c-.005-1.39-1.082-3.039-2.449-3.554A25.6 25.6 0 0 0 9.731.97C8.267 1.08 6.715 2.462 6.3 3.685A64.146 64.146 0 0 0 3.296 22.91c-.027 1.534.82 2.978 2.235 3.168a2.583 2.583 0 0 0 2.363-.946 2.583 2.583 0 0 0 4.392.59 2.583 2.583 0 0 0 4.392.59 2.583 2.583 0 0 0 2.029 1.538c1.414.19 2.698-1.085 2.986-2.313ZM17.213 7.04l-6.838 5.08a1.65 1.65 0 0 0-.34 2.308c.543.731 3.052.919 3.052.919l-3.606 2.679a1.65 1.65 0 1 0 1.969 2.65l6.81-5.059a1.65 1.65 0 0 0 .34-2.31c-.543-.732-3.007-.953-3.007-.953l3.588-2.665a1.65 1.65 0 1 0-1.968-2.65Z"
    />
  </Icon>
);

export default ListrikPln;
